<template>
  <div class="dish-card-component active">
    <div class="header-section">
      <span class="card-title font-weight-medium">Салат Цезарь</span>
      <hr />
    </div>

    <div class="body-section d-flex align-center justify-center flex-column">
      <div class="image-section d-flex justify-center">
        <div v-if="timer" class="timer d-flex align-center justify-center">
          <span>00</span>
          <span>:</span>
          <span>00</span>
        </div>
        <img src="/roll.jpg" alt="food" />
      </div>
      <div class="stickers-section">
        <div class="sticker quantity">
          <span>2</span>
        </div>
        <div class="sticker crafted">
          <span>СБ</span>
        </div>
      </div>
    </div>

    <div class="footer-section d-flex align-center justify-space-between">
      <div class="icon-cooking-method">
        <font-awesome-icon icon="weight-hanging" />
      </div>
      <div class="weight d-flex align-center">
        <div class="weight-icon">
          <font-awesome-icon icon="weight-hanging" />
        </div>
        <span class="weight-number">300</span>
        <span class="units">г</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DishCard',
    props: {
      timer: {
        type: Object,
        default: null,
      },
    },
  }
</script>

<style lang="less" scoped>
.dish-card-component {
  position: relative;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 3px 6px #00000029;
  border: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 1;

  &.active {
    background-color: #ffffff;

    &:before {
      content: '';
      border-radius: 3px;
      position: absolute;
      left: -12px;
      top: -12px;
      width: calc(100% + 24px);
      height: calc(100% + 24px);
      background-color: rgba(@color-primary, 0.5);
      z-index: -1;
    }
  }

  .header-section {
    background-color: #ffffff;

    hr {
      width: 100%;
      height: 1px;
      border: 0;
      background-color: rgba(0, 0, 0, 0.2);
    }

    .card-title {
      color: #000000;
      font-size: 24px;
      text-align: center;
      display: block;
      margin-bottom: 5px;
    }
  }

  .body-section {
    position: relative;
    background-color: #ffffff;
    z-index: 0;

    .stickers-section {
      position: absolute;
      padding-top: 8px;
      left: 8px;
      top: 0;
      z-index: 1;

      .sticker {
        background-color: #1ee984;
        padding: 5px 15px;
        border-radius: 120px;
        font-size: 24px;
        font-weight: 900;
        color: #ffffff;
        text-align: center;
        margin-bottom: 8px;

        &.quantity {
          background-color: #614ee2;
        }

        &.crafted {
          background-color: #e91e63;
        }
      }
    }

    .image-section {
      width: 100%;
      height: 159px;

      .timer {
        position: absolute;
        background-color: rgba(#ff5252, 0.8);
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 2;

        span {
          font-size: 56px;
          font-weight: 900;
          color: #ffffff;
        }
      }

      img {
        height: 100%;
      }
    }
  }

  .footer-section {
    padding: 10px 16px 10px 16px;
    justify-content: space-between;
    background-color: #ffffff;

    .icon-cooking-method {
      svg {
        width: 30px;
        height: 30px;
      }
    }

    .weight {
      span {
        font-weight: 900;
      }

      .weight-icon {
        margin-right: 8px;

        svg {
          width: 30px;
          height: 30px;
        }
      }

      .weight-number,
      .units {
        font-size: 18px;
      }
    }
  }
}
</style>
